module.exports = __webpack_public_path__ + "static/img/IMG_20170303_162907.2f91994e.jpg";